import { Injectable } from '@angular/core';
//import * as signalR from '@microsoft/signalr';
import {HubConnectionState,HubConnectionBuilder,LogLevel,HttpTransportType,DefaultHttpClient} from '@microsoft/signalr';
import { BaseConfig } from './base-config.service';
import { UserCache } from './user-cache';
import { IBaseConfig } from '../shared/models/base-config';
import { ClinicDataService } from './data-service/clinic-data-service';
import { ClinicEventHandler } from './signalr-event-handler/clinic-event-handler';
import { delay, generateUUID } from '../shared/utilities';
import { CompanyEventHandler } from './signalr-event-handler/company-event-handler';
import { UserEventHandler } from './signalr-event-handler/user-event-handler';
import { SystemEventHandler } from './signalr-event-handler/system-event-handler';
import { AuthenticationService } from '../security/services/authentication.service';
import { UserConfirmService } from './user-confirm.service';
import { EasyFormService } from './easy-form-service';
import { EasyNotificationService } from './easy-notification.service';
import { ConsoleApi } from './api-service/console-api.service';
import { ConsoleInfo, HcrService } from './hcr-service.service';
import { LocalStoragesService } from './local-storages.service';
import { DebugNotifyService } from './debug-notify.service';
import { DebugLogService } from './debug-log.service';
import { SignalRConnectionIdService } from './signalr-connection-id.service';
import { PetContextSnapshot, PetPairing } from './pet-context.models';

export type Notify = (data: string) => void;
export enum AccessCheckLevel {
  User = 0,
  Clinic = 1,
  Company = 2
}
export declare type GroupMsgData = {
  Group: 'Clinic' | 'Company' | 'User';//自訂自行擴充
  Type: 'Action' | 'Notify' | 'Alert';
  Act: string;
  Arg: any;
}
@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private readonly signalRKeepAliveIntervalInMilliseconds = 15000;
  private readonly signalRServerTimeoutInMilliseconds = 120000;
  private hubConnection: signalR.HubConnection;
  private authExpiredHandling = false;
  get ConnId() {
    return this.hubConnection?.connectionId || '';
  }
  get State() {

    return this.hubConnection.state;
  }
  // 保留的連線Id,與Server斷線(close)重新接回後，通知Server移除之前的ConnId
  private prevConnId: string;
  config: IBaseConfig;
  public notify: Notify;
  private clinicId: number;
  private user: string;
  private sysStTime: number = 0;
  private showRefrechConfirm: boolean = true;
  private autoReconnectEnable = false;

  private errorLog:string[] = [];
  constructor(private clinicData: ClinicDataService,
    private auth: AuthenticationService,
    private clinicEvt: ClinicEventHandler,
    private companyEvt: CompanyEventHandler,
    private userEvt: UserEventHandler,
    private systemEvt: SystemEventHandler,
    private ezForm: EasyFormService,
    private ezNotify:EasyNotificationService,
    private api:ConsoleApi,
    private hcrService:HcrService,
    private localStorage:LocalStoragesService,
    private userConfirm:UserConfirmService,
    private debugNotify:DebugNotifyService,
    private logger:DebugLogService,
    private connectionIdService: SignalRConnectionIdService
  ) {
    // load config from BaseConfig
    this.config = BaseConfig.getConfig();
    const user = UserCache.getLoginUser();
    if (user !== null) {
      this.user = user.Clinic.Id + '@' + user.Account;
      this.clinicId = user.Clinic.Id;
    }
    setInterval(() => {
      this.connectionAlive()
    }, 30000)
  }

  private connectionAlive() {
    if (this.hubConnection?.state == HubConnectionState.Connected) {
      var localinfo: ConsoleInfo = this.localStorage.getItem('ConsoleInfo') ?? {}
      this.hubConnection.invoke('Alive',this.hcrService.ConnectStatus,localinfo?.ComputerName??'');
    }
  }

  get petReceiverUrl(): string {
    const base = new URL(this.config.webApi.hubUrl.replace(/\/?$/, '/'), window.location.origin);
    return new URL('pet-receiver', base).toString();
  }

  createPetPairing(publisherId: string): Promise<PetPairing> {
    if (this.hubConnection?.state !== HubConnectionState.Connected) return Promise.reject(new Error('SignalR unavailable'));
    return this.hubConnection.invoke('CreatePetPairing', publisherId);
  }

  publishPetContext(publisherId: string, value: PetContextSnapshot): Promise<boolean> {
    if (this.hubConnection?.state !== HubConnectionState.Connected) return Promise.reject(new Error('SignalR unavailable'));
    return this.hubConnection.invoke('PublishPetContext', publisherId, value);
  }

  revokePetPairing(publisherId: string): Promise<void> {
    if (this.hubConnection?.state !== HubConnectionState.Connected) return Promise.reject(new Error('SignalR unavailable'));
    return this.hubConnection.invoke('RevokePetPairing', publisherId);
  }

  public get Url(){
    return this.hubConnection?.baseUrl??"";
  }
  public async startConnection(onConnected: (a: string) => void,logger:signalR.ILogger = new DefaultLogger()) { // : Observable<Observable<void>> {
    this.authExpiredHandling = false;
    this.connectionIdService.setConnectionId('');
    this.hubConnection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Debug)
      .withUrl(this.config.webApi.hubUrl + 'chathub', {
        transport:HttpTransportType.WebSockets,
        accessTokenFactory: () => UserCache.getLoginUser()?.AuthToken ?? '',
        // accessTokenFactory: () => user.AuthToken,
        // 自訂義Header附加CompanyCode
        httpClient:new VisionSignalRHttpClient(this.config, () => {
          const loginUser = UserCache.getLoginUser();
          return {
            authToken: loginUser?.AuthToken ?? '',
            companyCode: loginUser?.CompanyCode ?? ''
          };
        }, logger),
      })
      .build();
    this.hubConnection.keepAliveIntervalInMilliseconds = this.signalRKeepAliveIntervalInMilliseconds;
    this.hubConnection.serverTimeoutInMilliseconds = this.signalRServerTimeoutInMilliseconds;

    this.hubConnection.on('SysStTime', async (sysStTime: number) => {
      if (this.sysStTime && this.sysStTime != sysStTime) {
        if (this.showRefrechConfirm) {
          var ret = await this.ezForm.show({
            'msg': '偵測到系統更新，請重新整理網頁後再繼續使用。',
            'title': '版本更新',
            'fields': {
              skip: {
                'type': 'check',
                'label': '不再提醒',
                'name': 'skip',
                'value': false
              }
            },
            'hideClose': true,
            'showBtnCancel': false,
            'textOk': '稍後重新整理',
            'textCancel': '立即重新整理',
            'btns': [{
              'text': '立即重新整理',
              'callback': () => {
                location.reload();
              }
            }]
          });
          this.showRefrechConfirm = !ret.skip;
        }
      } else {
        this.sysStTime = sysStTime;
      }
    })
    // 執行指令並向Server端回報完成
    this.hubConnection.on('Command', async (data: {Id:string,Cmd:string,Args:any}) => {
      var ret = await this.systemEvt.Command(data.Cmd,data.Args);
      this.hubConnection.invoke('CommandResult',data.Id,ret)
    })
    // 當發出的指令在Server端收到結果後通知回來
    this.hubConnection.on('CommandResult', async (Id:string,data: any) => {
      await this.OnCommandResult(Id,data)
      //this.ezNotify.showSuccess(JSON.stringify(data));
    })
    this.hubConnection.onreconnected(async (connectionId) => {
      this.connectionIdService.setConnectionId(connectionId || this.hubConnection?.connectionId || '');
      this.logInfo('SignalR Reconnected')
      if(this.errorLog.length>0){
        var e = this.errorLog;
        //先清空 再送出
        this.errorLog = [];
        await this.debugNotify.Notify('SignalR Reconnected\r\n' + e.join('\r\n'));

        onConnected(this.hubConnection.connectionId);
      }
    })
    this.hubConnection.onreconnecting(() => {
      this.connectionIdService.setConnectionId('');
      this.logInfo('SignalR Reconnecting');
    })
    this.hubConnection.onclose(async (er) => {
      this.connectionIdService.setConnectionId('');
      this.logInfo('SignalR Closed '+ this.prevConnId+' '+  er);
      var dt = new Date().toISOString();
      this.errorLog.push(`[${dt}]SignalR Closed, reason: ${er}`)
      if (await this.handleUnauthorized('SignalR Closed', er)) {
        return;
      }
      if (this.autoReconnectEnable) {
        await this.autoReconnect(onConnected);
      }
    })
    try {
      var prev = this.prevConnId;
      await this.hubConnection.start();
      this.authExpiredHandling = false;
      this.connectionIdService.setConnectionId(this.hubConnection.connectionId);
      this.prevConnId = this.hubConnection.connectionId;
      this.autoReconnectEnable = true;
      if (prev) {
        await this.hubConnection.invoke('RemovePrevConnectId', prev);
      }
      this.logInfo('SignalR Connected:'+ this.hubConnection.connectionId);
      this.logInfo('SignalR BaseUrl'+ this.hubConnection.baseUrl);
      this.connectionAlive();
      onConnected(this.hubConnection.connectionId);
    } catch (e) {
      this.connectionIdService.setConnectionId('');
      if (await this.handleUnauthorized('SignalR open fail', e)) {
        return;
      }
      this.logError('SignalR open fail ' + e);
    }
    this.auth.logoutEvent.subscribe(async x => {
      await this.StopConnection();
    });
  }
  public async StopConnection() {
    this.autoReconnectEnable = false;
    await this.hubConnection.stop()
    this.connectionIdService.setConnectionId('');
  }
  private async autoReconnect(onConnected:(a: string) => void) {
    try {
      this.logInfo('SignalR start AutoReconnect');
      await delay(Math.random() * 1000 + 4);
      if (this.hubConnection.state == HubConnectionState.Disconnected) {
        var prev = this.prevConnId;
        await this.hubConnection.start();
        this.connectionIdService.setConnectionId(this.hubConnection.connectionId);
        this.prevConnId = this.hubConnection.connectionId;
        if (prev) {
          await this.hubConnection.invoke('RemovePrevConnectId', prev);
        }
        this.connectionAlive();
        onConnected(this.hubConnection.connectionId);
      }
    } catch (e) {
      if (await this.handleUnauthorized('SignalR AutoReconnect fail', e)) {
        return;
      }
      this.logError('SignalR AutoReconnect fail '+ JSON.stringify(e));
      await this.autoReconnect(onConnected);
    }
  }

  private isUnauthorizedError(error: any): boolean {
    if (!error) {
      return false;
    }

    const status = error?.statusCode ?? error?.status ?? error?.error?.status ?? error?.error?.statusCode;
    if (status === 401) {
      return true;
    }

    const errorText = [
      error?.message,
      error?.error?.message,
      error?.error?.Message,
      error?.stack,
      typeof error === 'string' ? error : null
    ].filter(x => !!x).join(' ').toLowerCase();

    return errorText.includes('401') || errorText.includes('unauthorized');
  }

  private async handleUnauthorized(source: string, error: any): Promise<boolean> {
    if (!this.isUnauthorizedError(error)) {
      return false;
    }
    if (this.authExpiredHandling) {
      return true;
    }

    this.authExpiredHandling = true;
    this.autoReconnectEnable = false;
    this.logError(`${source} unauthorized: ${this.stringifyError(error)}`);
    await this.auth.logout();
    return true;
  }

  private stringifyError(error: any): string {
    if (typeof error === 'string') {
      return error;
    }
    try {
      return JSON.stringify(error);
    } catch {
      return `${error}`;
    }
  }

  public userLogin() {
    var user = UserCache.getLoginUser();
    if (!user) {
      this.notify('使用者尚未登入');
    }

    var companyGroup = 'company'
    var clinicGroup = 'clinic'
    var userGroup = `User_${user.UserId}`;
    var systemGroup = 'system';
    // 集團群組
    this.joinGroup(companyGroup);
    // 診所群組
    this.joinGroup(clinicGroup);
    // 個人群組(多重登入)
    this.joinGroup(userGroup);
    // 系統群組
    this.joinGroup(systemGroup);
    this.hubConnection.off('ClinicMessage');
    this.hubConnection.on('ClinicMessage', (data: GroupMsgData) => {
      this.clinicEvt.Invoke(data);
    });
    this.hubConnection.off('CompanyMessage');
    this.hubConnection.on('CompanyMessage', (data: GroupMsgData) => {
      this.companyEvt.Invoke(data);
    });
    this.hubConnection.off('UserMessage');
    this.hubConnection.on('UserMessage', (data: GroupMsgData) => {
      this.userEvt.Invoke(data);
    });
    this.hubConnection.off('SystemMessage');
    this.hubConnection.on('SystemMessage', (data: GroupMsgData) => {
      this.systemEvt.Invoke(data);
    });
  }
  public consoleLogin(onMessage:(data:GroupMsgData)=>void) {

    this.joinGroup('console');
    this.hubConnection.off('ClinicMessage');
    this.hubConnection.on('ClinicMessage', (data:GroupMsgData)=>{
      onMessage(data);
    } );
  }

  public BroadcastClinic(data: GroupMsgData) {
    //var clinicGroup = 'clinic_' + UserCache.getLoginUser().Clinic.Code;
    var msg: GroupMsgData = {
      Group: 'Clinic',
      Type: 'Notify',
      Arg: 'Hello',
      Act: ''
    }
    this.hubConnection.invoke('Broadcast', msg)
      .catch(err => console.error(err));
  }

  public joinGroup(group: string) {
    this.hubConnection.invoke('JoinGroup', /*this.user,*/ group)
      .catch(err => console.error(err));

  }
  public leaveGroup(group: string) {
    this.hubConnection.invoke('LeaveGroup', group)
      .catch(err => console.error(err));
  }

  async CheckAccessAvailable(state: string, checkLevel: AccessCheckLevel, isCheck = false) {
    if(!isCheck) return false; //SignalR 前端 CheckAccessAvailable先return false，先不讓候診清單點選入會進不去診間 => 後續有空再處理
    return await this.hubConnection.invoke<string>("CheckAccessAvailable", state, checkLevel);
  }
  async CompleteAccess() {
    await this.hubConnection.invoke("CompleteAccess");
  }
  /**
   *
   *
   * @param {string} groupId 必須唯一，訊息收送群組
   * @param {string} data 通知的傳遞訊息
   * @memberof SignalRService
   */
  public registerNotify(groupId: string, data: string) {
    this.hubConnection.invoke('register', groupId, data)
      .catch(err => console.error(err));
  }

  public addRegisterNotifyListener = (notifyHandler: Notify) => {
    this.notify = notifyHandler;
    this.hubConnection.on('register', (data) => {
      this.notify(data);
      this.logInfo(data);
    });
  }
  private methodId: Map<string, { type: keyof NotifyType, fn: (...any) => void }> = new Map();
  /** 新增事件監聽，回傳監聽方法Id，作為呼叫removeNotifyListener的參數使用 */
  public addNotifyListener<K extends keyof NotifyType>(notifyType: K, notifyHandler: (data: NotifyType[K]) => void) {
    var fn = (data) => {
      notifyHandler(data);
    }
    var mId = generateUUID()
    this.methodId.set(mId, { type: notifyType, fn: fn });
    this.hubConnection.on(notifyType, fn);
    return mId
  }
  /** 解除事件監聽，傳入 addNotifyListener的回傳值 */
  public removeNotifyListener(mId: string) {
    var notifyType = this.methodId.has(mId) ? this.methodId.get(mId) : null;
    if (notifyType) {
      this.hubConnection.off(notifyType.type, notifyType.fn);
    }
  }
  public GenGroupId<K extends keyof NotifyType>(notifyType: K, ...parameters: string[]): string {
    let groupId = this.clinicId.toString(); // yogi modify 1104
    parameters.forEach((p) => {
      groupId += '@' + p;
    });
    groupId += '@' + notifyType;
    return groupId;
  }

  cmdIdMap:Map<string,string> = new Map();
  /** 發出指令 */
  async SendCommand(target:string, cmd:string,args:any,cmdDesc:string){
    var result = await this.api.Command({
      Command:cmd,
      Args:args,
      To:target,
      From:this.hubConnection.connectionId

    });
    var cmdId = result.cmdId;
    this.cmdIdMap.set(cmdId,cmdDesc);
  }
  /** 收到指令結果 */
  async OnCommandResult(cmdId:string,result:any){
    var cmdDesc = this.cmdIdMap.get(cmdId);
    this.cmdIdMap.delete(cmdId);
    this.ezNotify.showMore(cmdDesc,(()=>{
      this.userConfirm.showAlert(cmdDesc,result);
    }).bind(this));
  }

  async logInfo(msg:string){
    console.log(msg);
    this.logger.ClientLog('Info',true,'SignalR Service, '+ msg)
  }
  async logError(msg:string){
    console.log(msg);
    this.logger.ClientLog('Error',false,'SignalR Service, '+msg)
  }
}
export type DeclareMessage = {
  Msg: string,
  Type: 'Msg' | 'Fin' | 'ErrorFin'
}
export class NotifyType {
  DeclareMessage: DeclareMessage;
  DeclareXmlMsg: DeclareMessage;
  DeclareMsgAna33: DeclareMessage;
  RxUpdateMessage: RxUpdateMessage;
  Register: void;
  FinishOrder: any;
}
// export const enum NotifyType {
//   Register = 'Regist',
//   FinishOrder = 'OrderFinish',
//   SYSTEM = '_SYSTEM_',
//   ReceiveMessage = 'DeclareMessage'
// }
export type RxUpdateMessage = {
  Msg: string,
  Type: 'Msg' | 'Fin'
}


export class DefaultLogger implements signalR.ILogger{
  log(logLevel: signalR.LogLevel, message: string): void {
    console.log(logLevel,message);
  }
}
export class VisionSignalRHttpClient extends DefaultHttpClient {
  constructor(
    private config:IBaseConfig,
    private getAuthContext: () => { authToken: string, companyCode: string },
    logger:signalR.ILogger){
    super(logger);
  }
  /** @inheritDoc */
  send(request: signalR.HttpRequest): Promise<signalR.HttpResponse>{
    // 對webapi發
    if(request.url.startsWith(this.config.webApi.hubUrl)){
      if(request.headers==null){
        request.headers = {};
      }
      const authContext = this.getAuthContext();
      request.headers["CompanyCode"] = authContext.companyCode;
      if (authContext.authToken) {
        request.headers["Authorization"] = 'Bearer '+authContext.authToken;
      }
      return super.send(request)
    }else{
      // 對Azure發的jwtoken會在webapi中的設定處理使其包含companycode
      return super.send(request)
    }
  }
}
